import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {DockedPanel} from '../contexts/DockedPanelContext'
import {useMergeStatusButtonData} from '../hooks/use-merge-status-button-data'
import type {MergeStatusButtonData} from '../page-data/payloads/header'
import type {PullRequest} from '../types'
import {useMemo} from 'react'

export function useDetermineDockedPanels({
  pullRequest,
  mergeStatusButtonData,
}: {
  pullRequest: PullRequest
  mergeStatusButtonData?: MergeStatusButtonData
}): DockedPanel[] {
  const validatedMergeData = useMergeStatusButtonData(pullRequest.state, mergeStatusButtonData)
  const hasMergeStatus = !!validatedMergeData
  const hasAgentSessions = isFeatureEnabled('coding_agent_logs_in_pr')

  return useMemo(() => {
    const enabledPanels: DockedPanel[] = ['comments', 'overview'] // always enabled
    // TODO - skipped adding "Alerts" because we need further changes for empty states first

    if (hasMergeStatus) enabledPanels.push('mergeStatus')
    if (hasAgentSessions) enabledPanels.push('agentSessions')

    return enabledPanels.sort((a, b) => a.localeCompare(b))
  }, [hasMergeStatus, hasAgentSessions])
}
